<template>
    <div class="pa-5">
        <div v-for="classificator in productClassificators" v-if="classificator.assigned_tab === 'codes'">
            <div class="mb-2">
                <strong>{{ getClassificatorOrClassificatorRowTitle(classificator.title) }}</strong>
            </div>
            <div v-for="cr in classificator.rows">
                <v-row no-gutters v-if="cr.value_type === 'text' || cr.value_type === 'number'">
                    <v-col class="mt-2 row-title" cols="3">{{
                        getClassificatorOrClassificatorRowTitle(cr.title)
                    }}</v-col>
                    <v-col cols="6">
                        <classificator-input
                            :classificator_value="getClassificatorValue(cr.id, classificator.classificator_type)"
                            :classificator_row="cr"
                            :classificator_type="classificator.classificator_type"
                            @changeValue="changeClassificatorValue($event)"
                        />
                    </v-col>
                </v-row>
                <v-row no-gutters v-else-if="cr.value_type === 'boolean'">
                    <v-col class="mt-5 pr-2 row-title" cols="3">{{
                        getClassificatorOrClassificatorRowTitle(cr.title)
                    }}</v-col>
                    <v-col cols="6">
                        <classificator-checkbox-input
                            :classificator_value="getClassificatorValue(cr.id, classificator.classificator_type)"
                            :classificator_row="cr"
                            :classificator_type="classificator.classificator_type"
                            @changeValue="changeClassificatorValue($event)"
                        />
                    </v-col>
                </v-row>
                <v-row no-gutters v-else-if="cr.value_type === 'text_field'">
                    <v-col cols="9">
                        <classificator-text-area-input
                            :classificator_value="getClassificatorValue(cr.id, classificator.classificator_type)"
                            :classificator_row="cr"
                            :classificator_type="classificator.classificator_type"
                            @changeValue="changeClassificatorValue($event)"
                        />
                    </v-col>
                </v-row>
            </div>
            <v-divider class="mb-5 mt-2"></v-divider>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";
import ClassificatorInput from "../../../components/classificator-input.vue";
import { userTranslationFunctions } from "@/mixins/user-translation-functions";
export default {
    name: "codes-edit-tab",
    components: {
        ClassificatorInput
    },
    mixins: [userTranslationFunctions],
    data() {
        return {
            data: {}
        };
    },
    mounted() {},
    computed: {
        ...mapState("ProductStore", ["activeProduct", "productClassificators"])
    },
    methods: {
        ...mapMutations("ProductStore", ["changeClassificatorValue"]),
        getClassificatorValue(cr_id) {
            if (this.activeProduct.data && this.activeProduct.data.product_code) {
                const classificatorItemData = this.activeProduct.data.product_code.filter(
                    p => p.classificator_row_id === cr_id
                );
                if (classificatorItemData && classificatorItemData[0]) return classificatorItemData[0].value;
            }
            return null;
        }
    }
};
</script>

<style scoped>
.row-title {
    color: gray;
}
::v-deep .v-input__slot {
    min-height: 9px !important;
}
::v-deep .v-input__icon {
    padding-bottom: 8px;
}
</style>
